module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "tryout-review"
    }
  }, [_c('div', {
    staticClass: "form-horizontal form-bordered"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Kode Tryout")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$store.state.tryout.code))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Jenis Tryout")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [(_vm.$store.state.tryout.is_repeated) ? _c('strong', [_vm._v("INSTANT")]) : _c('strong', [_vm._v("BERJANGKA")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Nama Tryout")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$store.state.tryout.name))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Jenjang / Jenis")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$store.state.tryout.level) + " / " + _vm._s(_vm.$store.state.tryout.type))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Durasi")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$store.state.tryout.duration) + " menit")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Opsi")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [(_vm.$store.state.tryout.is_free_access) ? _c('strong', [_vm._v("Akses Gratis")]) : _vm._e(), _c('br'), _vm._v(" "), (_vm.$store.state.tryout.is_repeated) ? _c('strong', [_vm._v("Tryout Berulang")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Mulai")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$store.state.tryout.start_date) + " " + _vm._s(_vm.$store.state.tryout.start_time))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Berakhir")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$store.state.tryout.end_date) + " " + _vm._s(_vm.$store.state.tryout.end_time))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Subtests")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('table', {
    staticClass: "table table-hover"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.$store.state.tryout.subtests), function(subtest, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_c('img', {
      staticClass: "subject-picture",
      attrs: {
        "src": subtest.subject_picture
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(subtest.subject_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(subtest.details.length))])])
  }), 0)])])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [(_vm.isDraft) ? _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.confirmReview()
      }
    }
  }, [_vm._v("Ubah Status Ke REVIEW")]) : _vm._e(), _vm._v(" "), (_vm.isReviewed) ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.confirmDraft()
      }
    }
  }, [_vm._v("Kembali ke DRAFT")]) : _vm._e(), _vm._v(" "), (_vm.isReviewed) ? _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.confirmPublish()
      }
    }
  }, [_vm._v("Ubah Status ke PUBLISHED")]) : _vm._e()]), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('td', [_vm._v("#")]), _vm._v(" "), _c('td', [_vm._v("Gambar")]), _vm._v(" "), _c('td', [_vm._v("Mata Pelajaran")]), _vm._v(" "), _c('td', [_vm._v("Jumlah Soal")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-176baf4d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tryout/Review.vue
// module id = 1290
// module chunks = 0